import React from "react";
import { Quote, Star } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { TESTIMONIALS } from "../mock";
import SectionHeader from "./SectionHeader";
import useReveal from "../hooks/useReveal";

export default function Testimonials() {
  const { t, S } = useLang();
  const ref = useReveal();

  return (
    <section ref={ref} className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <SectionHeader kicker={t(S.testimonials.kicker)} title={t(S.testimonials.title)} />

        <div className="mt-14 grid md:grid-cols-3 gap-7">
          {TESTIMONIALS.map((r, i) => (
            <div
              key={r.id}
              className="reveal card-lift rounded-2xl bg-secondary/40 border border-border p-8"
              style={{ transitionDelay: `${i * 90}ms` }}
            >
              <Quote className="w-9 h-9 text-primary/30" />
              <div className="mt-3 flex gap-1">
                {[...Array(5)].map((_, k) => (
                  <Star key={k} className="w-4 h-4 text-accent fill-accent" />
                ))}
              </div>
              <p className="mt-4 text-foreground leading-relaxed">{t(r.text)}</p>
              <div className="mt-6 flex items-center gap-3">
                <span className="grid place-items-center w-11 h-11 rounded-full bg-primary text-primary-foreground font-display font-bold">
                  {r.name.charAt(0)}
                </span>
                <span className="font-semibold text-foreground">{r.name}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
